/**
 * custom-js.js
 * Shared scoped behavior for every custom page/section (custom-main-blog,
 * custom-main-article, custom-newsletter, ...) — same "custom pages"
 * system, so they all share this one file rather than having their own.
 *
 * Added section by section as those pages/sections are built.
 */

(function () {
  'use strict';

  // After a native (non-AJAX) customer-form submit, Shopify redirects back
  // to ?form_type=customer&customer_posted=true. Clean those params out of
  // the URL so a later manual refresh behaves like a normal refresh — no
  // re-shown success message. (sections/custom-newsletter.liquid submits in
  // the background and cleans up after itself; this still covers Dawn's
  // own footer/newsletter signup forms.)
  var params = new URLSearchParams(window.location.search);

  if (params.has('customer_posted')) {
    params.delete('form_type');
    params.delete('customer_posted');

    var query = params.toString();
    var cleanUrl = window.location.pathname + (query ? '?' + query : '');

    window.history.replaceState(null, '', cleanUrl);
  }
})();

(function () {
    'use strict';

    // Product gallery (custom-main-product.liquid) — thumbnails, prev/next
    // arrows, a click-to-zoom modal, keyboard navigation, and touch swipe,
    // all driven off one shared "go to slide" function so every control
    // stays in sync. Not Dawn's own <media-gallery> custom element — this
    // stays self-contained rather than pulling in Dawn's full zoom/modal/
    // carousel machinery.
    var gallery = document.querySelector('.product-custom__gallery');
    var mainImage = document.querySelector('[data-product-custom-main-image]');

    if (!gallery || !mainImage) return;

    // Build the slide list from the thumbnails' data-* attributes. If
    // there's only one image, there are no thumbnails (guarded by
    // {% if product.images.size > 1 %} in the Liquid) — fall back to a
    // single slide built from the main image's own initial attributes, so
    // the zoom modal still works for single-image products even though
    // there's nothing to page through.
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-custom-thumb]'));
    var slides = thumbs.map(function (thumb) {
        return {
            full: thumb.getAttribute('data-full'),
            srcset: thumb.getAttribute('data-srcset'),
            zoom: thumb.getAttribute('data-zoom'),
            alt: thumb.getAttribute('data-alt'),
            width: thumb.getAttribute('data-width'),
            height: thumb.getAttribute('data-height')
        };
    });

    if (!slides.length) {
        slides = [{
            full: mainImage.src,
            srcset: mainImage.srcset,
            zoom: mainImage.getAttribute('data-zoom'),
            alt: mainImage.alt,
            width: mainImage.getAttribute('width'),
            height: mainImage.getAttribute('height')
        }];
    }

    var currentIndex = 0;
    var prevButtons = document.querySelectorAll('[data-product-custom-prev]');
    var nextButtons = document.querySelectorAll('[data-product-custom-next]');
    var counters = document.querySelectorAll('[data-product-custom-counter]');
    var zoomTrigger = document.querySelector('[data-product-custom-zoom-trigger]');
    var modal = document.querySelector('[data-product-custom-modal]');
    var modalImage = modal ? modal.querySelector('[data-product-custom-modal-image]') : null;
    var modalCloseTargets = modal ? modal.querySelectorAll('[data-product-custom-modal-close]') : [];
    var lastFocusedBeforeModal = null;
    var scrollLockY = 0;

    // Locks the page in place while the modal is open without touching
    // "overflow" — toggling overflow: hidden removes the scrollbar, which
    // changes the page's width and makes everything (header included)
    // visibly shift sideways for the duration, then shift back on close.
    // Pinning the body via position: fixed at its current scroll offset
    // keeps the scrollbar/page width untouched, so nothing shifts either
    // way; window.scrollTo below restores the exact scroll position.
    function lockBodyScroll() {
        scrollLockY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = (scrollLockY * -1) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
    }

    function unlockBodyScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        window.scrollTo(0, scrollLockY);
    }

    function goToSlide(index) {
        // Wraps around at both ends rather than stopping, same as most
        // product gallery carousels.
        currentIndex = (index + slides.length) % slides.length;
        var slide = slides[currentIndex];

        mainImage.src = slide.full;
        mainImage.srcset = slide.srcset || '';
        mainImage.alt = slide.alt;
        if (slide.width) mainImage.width = slide.width;
        if (slide.height) mainImage.height = slide.height;

        thumbs.forEach(function (thumb, index2) {
            var isActive = index2 === currentIndex;
            thumb.classList.toggle('product-custom__gallery-thumb--active', isActive);
            thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        counters.forEach(function (counter) {
            counter.textContent = (currentIndex + 1) + ' / ' + slides.length;
        });

        if (modalImage) {
            modalImage.src = slide.zoom || slide.full;
            modalImage.alt = slide.alt;
        }
    }

    thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
            goToSlide(index);
        });
    });

    prevButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            goToSlide(currentIndex - 1);
        });
    });

    nextButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            goToSlide(currentIndex + 1);
        });
    });

    // Zoom modal — opened from the dedicated zoom button or by clicking
    // the main image itself (cursor: zoom-in signals this in the CSS).
    function openModal() {
        if (!modal) return;

        lastFocusedBeforeModal = document.activeElement;
        goToSlide(currentIndex); // sync modal image to whatever's current

        modal.hidden = false;
        lockBodyScroll();

        var closeButton = modal.querySelector('.product-custom__zoom-modal-close');
        if (closeButton) closeButton.focus();

        document.addEventListener('keydown', onModalKeydown);
    }

    function closeModal() {
        if (!modal) return;

        modal.hidden = true;
        unlockBodyScroll();

        document.removeEventListener('keydown', onModalKeydown);

        if (lastFocusedBeforeModal && typeof lastFocusedBeforeModal.focus === 'function') {
            lastFocusedBeforeModal.focus();
        }
    }

    function onModalKeydown(event) {
        if (event.key === 'Escape') {
            closeModal();
        } else if (event.key === 'ArrowLeft') {
            goToSlide(currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
            goToSlide(currentIndex + 1);
        }
    }

    if (zoomTrigger) {
        zoomTrigger.addEventListener('click', openModal);
    }

    mainImage.addEventListener('click', openModal);

    modalCloseTargets.forEach(function (target) {
        target.addEventListener('click', closeModal);
    });

    // Touch swipe — main image and modal image both, left/right past a
    // small threshold moves to the next/previous slide. Vertical scrolling
    // still works normally since only horizontal movement counts.
    function addSwipeSupport(element) {
        if (!element) return;

        var startX = null;
        var startY = null;

        element.addEventListener('touchstart', function (event) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        }, { passive: true });

        element.addEventListener('touchend', function (event) {
            if (startX === null) return;

            var deltaX = event.changedTouches[0].clientX - startX;
            var deltaY = event.changedTouches[0].clientY - startY;

            // Require a mostly-horizontal swipe of at least 40px, so a
            // vertical scroll gesture doesn't accidentally change slides.
            if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
                goToSlide(currentIndex + (deltaX < 0 ? 1 : -1));
            }

            startX = null;
            startY = null;
        });
    }

    addSwipeSupport(mainImage);
    addSwipeSupport(modalImage);
})();

(function () {
    'use strict';

    // Blog grid view toggle (custom-main-blog.liquid) — switches the post
    // grid between the default multi-column grid and a fixed 2-per-row
    // list. Persisted in localStorage so the choice survives pagination
    // (a real page navigation/full reload, not an in-page swap) and
    // future visits — without this, clicking "next page" or a page
    // number always landed back on a fresh, unstyled page load and the
    // view silently reset to grid.
    var VIEW_KEY = 'blogCustomView';
    var toggleButtons = document.querySelectorAll('[data-view-toggle]');
    var grid = document.querySelector('[data-blog-grid]');

    function setView(view) {
        var isList = view === 'list';

        grid.classList.toggle('blog-custom__grid--list', isList);

        toggleButtons.forEach(function (btn) {
            var isActive = btn.getAttribute('data-view-toggle') === view;
            btn.classList.toggle('blog-custom__view-toggle-btn--active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
    }

    if (toggleButtons.length && grid) {
        var savedView = null;
        try {
            savedView = localStorage.getItem(VIEW_KEY);
        } catch (error) {
            // localStorage unavailable (private browsing, etc.) — falls
            // back to whatever the page rendered by default (grid).
        }

        if (savedView === 'list') {
            setView('list');
        }

        toggleButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                var view = button.getAttribute('data-view-toggle');

                setView(view);

                try {
                    localStorage.setItem(VIEW_KEY, view);
                } catch (error) {
                    // ignore — view still applies for this page, just
                    // won't be remembered next time
                }
            });
        });
    }
})();

(function () {
    'use strict';

    // Related articles mobile carousel (custom-main-article.liquid) — the
    // swipe itself is plain CSS scroll-snap, no JS needed for that. This
    // handles the dots (IntersectionObserver watches which card is most
    // visible and marks the matching dot active, click a dot to jump to
    // it) and optional autoplay. Runs harmlessly on desktop too (dots are
    // display: none there via CSS, the grid isn't horizontally scrollable
    // there, and autoplay checks the viewport width before ever starting).
    var MOBILE_BREAKPOINT = 749;

    var carousel = document.querySelector('[data-related-carousel]');
    var dotsContainer = document.querySelector('[data-related-dots]');

    if (!carousel || !dotsContainer || typeof IntersectionObserver === 'undefined') return;

    var items = Array.prototype.slice.call(carousel.querySelectorAll('[data-related-carousel-item]'));
    var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-related-dot]'));

    if (!items.length || !dots.length) return;

    var activeIndex = 0;

    function setActiveDot(index) {
        activeIndex = index;
        dots.forEach(function (dot, dotIndex) {
            var isActive = dotIndex === index;
            dot.classList.toggle('article-custom__related-dot--active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
    }

    function goToItem(index) {
        items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    var observer = new IntersectionObserver(function (entries) {
        // Multiple entries can report at once mid-swipe — take whichever
        // is most visible right now rather than acting on every entry.
        var mostVisible = entries.reduce(function (best, entry) {
            return entry.intersectionRatio > (best ? best.intersectionRatio : 0) ? entry : best;
        }, null);

        if (mostVisible && mostVisible.isIntersecting) {
            setActiveDot(items.indexOf(mostVisible.target));
        }
    }, {
        root: carousel,
        threshold: 0.6
    });

    items.forEach(function (item) {
        observer.observe(item);
    });

    dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
            stopAutoplay(); // clicking a dot is a manual choice, same as swiping
            goToItem(index);
        });
    });

    // Autoplay — merchant-controlled (id_related_autoplay / seconds
    // setting), advances to the next card on a timer. Stops permanently
    // the moment the visitor interacts manually (swipe or dot click) so
    // it never fights someone actively browsing, and pauses/resumes
    // automatically while the carousel scrolls in and out of view so it
    // doesn't keep silently advancing off-screen or surprise the visitor
    // mid-transition when they scroll back to it.
    var autoplayEnabled = carousel.getAttribute('data-related-autoplay') === 'true';
    var autoplaySeconds = parseInt(carousel.getAttribute('data-related-autoplay-seconds'), 10) || 3;
    var autoplayTimer = null;
    var autoplayStoppedManually = false;

    function isMobileCarouselActive() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function startAutoplay() {
        if (!autoplayEnabled || autoplayStoppedManually || items.length < 2 || !isMobileCarouselActive()) {
            return;
        }

        stopAutoplayTimer();
        autoplayTimer = window.setInterval(function () {
            goToItem((activeIndex + 1) % items.length);
        }, autoplaySeconds * 1000);
    }

    function stopAutoplayTimer() {
        if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    }

    function stopAutoplay() {
        autoplayStoppedManually = true;
        stopAutoplayTimer();
    }

    if (autoplayEnabled) {
        carousel.addEventListener('touchstart', stopAutoplay, { passive: true, once: true });

        var visibilityObserver = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                startAutoplay();
            } else {
                stopAutoplayTimer();
            }
        }, { threshold: 0.5 });

        visibilityObserver.observe(carousel);
    }
})();

(function () {
    'use strict';

    // Required-field validation, shared by every custom form that opts
    // in — currently the Contact form (custom-main-contact-2.liquid) and
    // the Become a Dealer form (custom-main-dealer.liquid), same pattern
    // for any future one. Opt in per form with:
    //   - the plain CSS class `js-required-validation` on the <form>
    //     itself (added alongside its own namespaced class — Shopify's
    //     {% form %} tag's own `class:` argument is the one part of this
    //     that goes through Liquid's tag-argument parsing, so this
    //     sticks to a mechanism already proven to work there rather than
    //     a data-* attribute name, which is unverified in that specific
    //     position).
    //   - `data-error-message="..."` on each field that should block
    //     submission when empty (or, for an <input type="email">,
    //     malformed) — plain HTML on the <input>/<textarea> itself, so
    //     no such parsing concern there. That's the exact text shown in
    //     its inline error.
    //
    // Why this exists at all: Shopify's native {% form 'contact' %} only
    // ever server-side-validates the email field (form.errors can only
    // ever contain "email") — every other field is otherwise accepted
    // blank with no error at all. The plain `required` attribute on each
    // field (in the Liquid) is the fallback if this script fails to
    // load, giving the browser's own native validation bubbles as a
    // backstop; this replaces that with inline, consistently-styled
    // messages next to each field instead.
    var forms = document.querySelectorAll('form.js-required-validation');

    forms.forEach(function (form) {
        // Only switches off the browser's own validation UI once JS is
        // confirmed running, so the two never show at once and a no-JS
        // visitor still gets real (if plainer) enforcement.
        form.noValidate = true;

        var requiredFields = Array.prototype.slice.call(form.querySelectorAll('[required]'));

        function errorElementFor(field) {
            return document.getElementById(field.id + '-error');
        }

        function isFieldValid(field) {
            // checkValidity() alone already catches "empty" for a
            // required field, but spelling it out here means
            // whitespace-only input (e.g. a name field containing just
            // spaces) is caught too.
            return field.value.trim() !== '' && field.checkValidity();
        }

        function showError(field) {
            var errorElement = errorElementFor(field);

            field.classList.add('is-invalid');
            field.setAttribute('aria-invalid', 'true');

            if (errorElement) {
                errorElement.textContent = field.getAttribute('data-error-message') || 'This field is required.';
                errorElement.hidden = false;
            }
        }

        function clearError(field) {
            var errorElement = errorElementFor(field);

            field.classList.remove('is-invalid');
            field.removeAttribute('aria-invalid');

            if (errorElement) {
                errorElement.hidden = true;
                errorElement.textContent = '';
            }
        }

        requiredFields.forEach(function (field) {
            // Clears the error the moment the visitor fixes it, rather
            // than leaving it up until their next submit attempt.
            field.addEventListener('input', function () {
                if (field.classList.contains('is-invalid') && isFieldValid(field)) {
                    clearError(field);
                }
            });
        });

        // Runs every required field through validation, showing/clearing
        // each one's inline error as needed. Returns the first invalid
        // field found (or null if everything's valid) so the caller can
        // decide whether to block submission and where to send focus.
        function validate() {
            var firstInvalidField = null;

            requiredFields.forEach(function (field) {
                if (isFieldValid(field)) {
                    clearError(field);
                } else {
                    showError(field);
                    if (!firstInvalidField) firstInvalidField = field;
                }
            });

            return firstInvalidField;
        }

        // Two independent interception points, not just one:
        //
        // 1. A capture-phase listener on the submit button's own "click"
        //    — runs before the browser starts its submit sequence at
        //    all, so nothing else reacting to that same click (another
        //    script on the page, a browser extension, a submit-time
        //    redirect some integration wires up) gets a chance to act on
        //    it first.
        // 2. The form's own "submit" event, as a second, independent
        //    check — catches implicit submission too (pressing Enter
        //    inside a text field submits the form without ever clicking
        //    the button, so a click-only guard alone would miss it).
        //
        // Both call the exact same validate(), so there's no separate
        // "click" vs "submit" logic to keep in sync — just two different
        // moments that both ask the same question and both stop the same
        // way (preventDefault + stopImmediatePropagation) the instant
        // either one finds a problem.
        var submitButton = form.querySelector('button[type="submit"]');

        if (submitButton) {
            submitButton.addEventListener('click', function (event) {
                var firstInvalidField = validate();
                if (firstInvalidField) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    firstInvalidField.focus();
                }
            }, true);
        }

        form.addEventListener('submit', function (event) {
            var firstInvalidField = validate();
            if (firstInvalidField) {
                event.preventDefault();
                event.stopImmediatePropagation();
                firstInvalidField.focus();
            }
        }, true);
    });
})();

(function () {
    'use strict';

    // Background (no-navigation) form submission — opt in per form
    // with the plain CSS class js-background-form, plus a hidden
    // <iframe name="<form id>-frame">> sitting elsewhere on the page
    // (name convention: the form's own id + "-frame", so no extra
    // attribute is needed on the form itself — a data-* attribute
    // would have to be added via the {% form %} tag's own argument
    // hash, an unverified position for a hyphenated key; `id:` is
    // already proven safe there and every custom form already sets
    // one). Currently used by custom-main-bruder-ag176.liquid, the
    // same pattern intended for the other WordPress/Elementor page
    // exports still to come — each with its own form id/iframe pair,
    // no JS changes needed per page.
    //
    // Shopify's normal POST -> redirect -> GET flow (via the form's
    // own return_to field) takes the visitor back to the very top of
    // the page just to show a plain success message — not what a
    // single-page-feeling imported landing page should do. Fix: set
    // the form's `target` to that same-page hidden iframe, so the
    // browser does the *exact* same real submission it always would
    // (same encoding, same cookies — no fetch/CORS/encoding guessing
    // involved), it's simply targeted at that invisible iframe rather
    // than the top-level window. This only sets `target` here, in JS —
    // never as a static HTML attribute — so a visitor with JS
    // disabled gets a form with no target at all, and falls back
    // cleanly to a normal full-page submission + the return_to
    // redirect instead.
    //
    // Runs after the required-field validation block above (later
    // registration order on the same capture-phase "submit" listener
    // list) — an invalid submission never reaches this handler at
    // all, because that block's own listener already calls
    // stopImmediatePropagation() before this one would run.
    var forms = document.querySelectorAll('form.js-background-form');

    forms.forEach(function (form) {
        var iframeName = form.id ? form.id + '-frame' : null;
        var iframe = iframeName ? document.querySelector('iframe[name="' + iframeName + '"]') : null;
        var successEl = form.querySelector('[data-background-success]');
        var submitButton = form.querySelector('button[type="submit"]');
        var submitButtonDefaultText = submitButton ? submitButton.textContent : null;

        if (!iframe) return;

        form.target = iframeName;

        var hasSubmitted = false;

        form.addEventListener('submit', function () {
            hasSubmitted = true;

            // Disable the button the instant a valid submission actually
            // starts (nothing before this point calls preventDefault, so
            // reaching here means the required-field check above already
            // passed). Without this, there was no visible feedback at
            // all while the background POST was in flight — on a normal
            // connection that easily reads as "nothing happened" for a
            // second or two, inviting a second click. That second click
            // starts a *new* navigation inside the same hidden iframe,
            // which cancels whatever the first click's request was still
            // doing — and two near-identical submissions seconds apart
            // is exactly the pattern Shopify's own contact-form spam
            // filtering can silently drop without ever emailing the
            // merchant, even though a "success"-looking response still
            // comes back from whichever request the iframe ends up
            // loading. Disabling the button makes a second click
            // impossible until the first request has actually finished.
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = submitButton.getAttribute('data-loading-text') || 'Sending…';
            }
        });

        iframe.addEventListener('load', function () {
            // Ignore the iframe's own initial (empty) load — only a
            // load that follows an actual form submission counts.
            if (!hasSubmitted) return;
            hasSubmitted = false;

            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = submitButtonDefaultText;
            }

            if (successEl) {
                successEl.hidden = false;
                successEl.setAttribute('tabindex', '-1');
                successEl.focus();
            }

            form.reset();
        });
    });
})();

(function () {
    'use strict';

    // Shopify's native {% form 'contact' %} redirects back to
    // return_to with its own ?contact_posted=true query param appended
    // on a successful submission — that literal flag is what
    // {{ form.posted_successfully? }} checks for in Liquid. Left alone,
    // it stays in the visible address bar until the visitor navigates
    // elsewhere, so a manual refresh of that same address keeps
    // re-showing the success message forever instead of a fresh, blank
    // form (reported on custom-main-dealer.liquid /
    // custom-main-referral-program.liquid after both were reverted
    // away from the js-background-form/hidden-iframe technique, which
    // avoided this but turned out to silently break Shopify's own
    // contact-form email delivery instead — see those files' own
    // comments).
    //
    // Fix: strip just the query string from the address bar the moment
    // the page loads with that flag present, via history.replaceState —
    // this only rewrites what's shown in the address bar, it doesn't
    // reload anything or touch what's already rendered (the success
    // message on THIS load stays exactly as Liquid already decided it
    // should be; the hash, if any, is left alone). A genuine manual
    // refresh after that then requests the now-clean URL, so
    // form.posted_successfully? is false again and the message
    // disappears — without any background/iframe submission trick.
    if (
        window.location.search.indexOf('contact_posted=true') !== -1 &&
        window.history &&
        window.history.replaceState
    ) {
        window.history.replaceState(null, '', window.location.pathname + window.location.hash);
    }
})();

(function () {
    'use strict';

    // Article sidebar (custom-main-article.liquid) — sticks at the top
    // (header height + 20px, set in custom-css.css). With the section's
    // "Sidebar scrolling" setting on "Whole sidebar reachable"
    // (data-sidebar-sticky="bottom"), a sidebar taller than the screen
    // (trust card + calculators card + featured unit on a laptop screen)
    // sticks by its bottom instead: a negative top lets it scroll up
    // until its last card is in view, then it stays there. Rechecked when
    // the window or the sidebar changes size (images loading, fonts
    // swapping). The default, "top", needs no JS.
    var sidebar = document.querySelector('.article-custom__sidebar[data-sidebar-sticky="bottom"]');

    if (!sidebar) return;

    function update() {
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        var bottomTop = window.innerHeight - sidebar.offsetHeight - 20;
        sidebar.style.top = bottomTop < header + 20 ? bottomTop + 'px' : '';
    }

    update();
    window.addEventListener('load', update);
    window.addEventListener('resize', update);
    if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(update).observe(sidebar);
    }
})();
